import type AccountPaymentInfo from "~/domains/payment/account/AccountPaymentInfo";
import type AccountProgramServiceInfo from "~/domains/payment/account/AccountProgramServiceInfo";
import { roundPrice } from "~/utils/payment";
import type DiscountInfo from "../../../DiscountInfo";
import type { DiscountInfoType } from "../../../DiscountInfoType";
import type ProgramServiceDiscountStrategy from "./ProgramServiceDiscountStrategy";

export default class ProgramProgramServiceDiscountStrategy implements ProgramServiceDiscountStrategy {
  getDiscountInfoType(): DiscountInfoType {
    return "program";
  }

  getDiscountInfo(accountProgramServiceInfo: AccountProgramServiceInfo, accountPaymentInfo: AccountPaymentInfo, currentSubtotal: number): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "program",
      description: "",
      value: 0,
      amount: 0,
    };

    const accountProgramInfo = accountPaymentInfo.programs.find((program) => program.id === accountProgramServiceInfo.programID);
    if (accountProgramInfo) {
      const programDiscountCode = accountPaymentInfo.discountCodes.find((discountCode) => discountCode.id === accountProgramInfo.discountCodeId);
      if (!!programDiscountCode) {
        const programDiscountValue = programDiscountCode.discountAmount ?? 0;
        const programDiscountDescription = `${programDiscountCode.discountDescription} (${
          programDiscountCode.dollarDiscount === 1 ? `${programDiscountValue}%` : `$${programDiscountValue}`
        }) - ${accountProgramInfo.title}`;
        const programDiscountAmount = accountProgramServiceInfo.programDiscountAmount ?? 0;
    
        discountInfo.description = programDiscountDescription;
        discountInfo.value = programDiscountValue;
        discountInfo.amount = roundPrice(programDiscountAmount, "nearest", 2);
      }
    }

    return discountInfo;
  }
}
